<script setup>
import { Bars3Icon } from '@heroicons/vue/24/solid'
import { Dropdown, DropdownItem } from '@codinglabsau/ui'
import SmallMagnifyingGlassIcon from '@/Components/SmallMagnifyingGlassIcon.vue'

defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <div class="flex items-center lg:hidden">
    <div class="flex h-full items-center">
      <Dropdown class="pt-1" text-classes="!border-none !shadow-none px-0">
        <template #text>
          <Bars3Icon class="size-7" />
        </template>

        <div v-for="item in items.filter((item) => item.visible)" :key="item.name">
          <div v-if="item.children">
            <div class="block bg-secondary/60 px-5 py-2 text-sm font-medium text-gray-700">
              <span>{{ item.name }}</span>
            </div>

            <DropdownItem
              v-for="child in item.children"
              :key="child.name"
              :href="child.href"
              :rel="child.nofollow ? 'nofollow' : null"
              class="border-l-2 border-transparent transition-all duration-150 ease-in-out hover:border-link-hover hover:text-link"
              :class="[
                child.current
                  ? '!border-link-hover font-bold text-link'
                  : 'font-medium text-gray-500',
              ]"
            >
              <span class="pl-4"> {{ child.name }} </span>
            </DropdownItem>
          </div>
          <DropdownItem
            v-else
            :key="item.name"
            :href="item.href"
            :rel="item.nofollow ? 'nofollow' : null"
            class="border-l-2 border-transparent transition-all duration-150 ease-in-out hover:border-link-hover hover:text-link"
            :class="[
              item.current ? '!border-link-hover font-bold text-link' : 'font-medium text-gray-500',
            ]"
          >
            {{ item.name }}
          </DropdownItem>
        </div>
      </Dropdown>

      <SmallMagnifyingGlassIcon class="ml-2 size-7" />
    </div>
  </div>
</template>
